import PropTypes from "prop-types";
import HorizontalLayout from "../../../../../lib/components/layouts/HorizontalLayout";
import InputDateTimePicker from "../../inputFields/InputDateTimePicker";
import VerticalLayout from "../../../../../lib/components/layouts/VerticalLayout";
import BaseComponent from "../../../../../lib/components/BaseComponent";

class StepDateSelection extends BaseComponent {

  onChange(e, value) {
    this.props.data.setDeliveryDateTime(value);
  }

  render() {
    let datetime = this.props.data.getDeliveryDateTime();

    return <HorizontalLayout className='gap-5'>
      <InputDateTimePicker
        defaultValue={datetime}
        labelElement='Datum und Uhrzeit'
        onChange={(e, id, value) => this.onChange(e, value)}/>
      <VerticalLayout className='justify-between'>
        <h5>Ausgewählter Datum und Uhrzeit:</h5>
        <p>{datetime.toLocaleDateString('de-CH', {
          year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric',
        })}</p>
      </VerticalLayout>
    </HorizontalLayout>;
  }
}

StepDateSelection.propTypes = {
  data: PropTypes.object.isRequired,
}

export default StepDateSelection;
